var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{staticClass:"Splitter"},[_c('Column',{staticClass:"left",attrs:{"lg":_vm.left}},[_vm._t("left")],2),_c('Column',{staticClass:"right",attrs:{"lg":_vm.right}},[_c('div',{staticClass:"Splitter-container"},[_c('div',{staticClass:"Splitter-body"},[_vm._t("right")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }